<script setup lang="ts">
import {computed} from "vue";
import Customer from "@/customer/interfaces/Customer";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Check, Smartphone} from "@lucide/vue";
import CustomerCertificationDialog from "@/customer/components/customer-certification/CustomerCertificationDialog.vue";
import Icon from "@/core/components/icon/Icon.vue";

const props = defineProps<{ customer: Customer }>();
const emit = defineEmits<{
    (e: 'certified'): void;
}>();

const noCertification = computed(() => {
    return props.customer.status === 'none' || props.customer.status === 'pending';
});

const certificationValidated = computed(() => {
    return props.customer.status === 'validated';
});
</script>

<template>
  <div>
    <CustomerCertificationDialog :customer="customer" @certified="emit('certified')">
      <template #activator="{props: activatorProps}">
        <BaseButton
          density="comfortable"
          v-bind="activatorProps"
          :class="{
            '!shadow-[2px_2px_2px_0_#65efca]': noCertification,
            'bg-secondary text-primary': !noCertification
          }"
        >
          <template v-if="noCertification">
            <Smartphone class="size-4 mr-1" />
            Connecter {{ customer.information?.first_name }}
          </template>
          <template v-else-if="!certificationValidated">
            <v-tooltip
              text="Le patient doit valider la certification sur son téléphone."
              location="bottom"
            >
              <template #activator="{ props }">
                <icon v-bind="props" class="h-5 w-5 mr-1 cursor-pointer" color="primary" name="mdi-information-outline" />
              </template>
            </v-tooltip>
            Certifié
            <Smartphone class="size-4 ml-1" />
          </template>
          <template v-else>
            <Check class="size-5 mr-1 stroke-[4px]" />
            Connecté
            <Smartphone class="size-4 ml-1" />
          </template>
        </BaseButton>
      </template>
    </CustomerCertificationDialog>
  </div>
</template>
